import React from 'react';
import { Card, Tooltip } from 'antd';
import { InfoCircleTwoTone } from '@ant-design/icons';
import styles from './styles/empty-card.module.scss';

const InfoIcon = () => (
    <Tooltip title="Additional information">
        <InfoCircleTwoTone twoToneColor="#8C8C8C" className={styles.infoIcon} />
    </Tooltip>
);

const EmptyCard = ({ title, showInfo = false, index = 0 }) => {
    const animationDelay = `${0.4 + (index * 0.05)}s`;
    
    return (
        <Card 
            className={styles.emptyCard} 
            title={title} 
            extra={showInfo ? <InfoIcon /> : null}
            style={{ animationDelay }}
        >
            <div className={styles.emptyValue}>-</div>
        </Card>
    );
};

export default EmptyCard;
